import { useThemeStore } from '@/store/themeStore';

const themes = [
  { value: 'dark' as const, icon: '🌙', label: 'Dark' },
  { value: 'light' as const, icon: '☀️', label: 'Light' },
  { value: 'system' as const, icon: '💻', label: 'System' },
];

export default function ThemeToggle() {
  const { theme, setTheme } = useThemeStore();

  return (
    <div className="flex items-center gap-0.5 bg-surface-100 dark:bg-surface-800 rounded-lg p-0.5">
      {themes.map((t) => (
        <button
          key={t.value}
          onClick={() => setTheme(t.value)}
          className={`px-2 py-1 rounded-md text-xs transition-all ${
            theme === t.value
              ? 'bg-white dark:bg-surface-700 shadow-sm text-surface-900 dark:text-white'
              : 'text-surface-500 dark:text-surface-400 hover:text-surface-700 dark:hover:text-surface-300'
          }`}
          title={t.label}
          aria-label={`Tema ${t.label}`}
        >
          {t.icon}
        </button>
      ))}
    </div>
  );
}
